module.exports = __webpack_public_path__ + "static/media/po_wco.53bcfa11.png";